/**
 * Detects whether the cursor is currently inside an unfinished @mention.
 * Used by ChatInput to decide whether to render the MentionPicker.
 */

export interface MentionContext {
  active: boolean;
  query: string; // text after `@`, may be empty
  atIndex: number; // index of `@` in the value, -1 when inactive
}

export function detectMentionContext(value: string, cursorPos: number): MentionContext {
  // Walk backwards from cursorPos.
  for (let i = cursorPos - 1; i >= 0; i--) {
    const ch = value[i] ?? "";
    if (ch === "@") {
      // Check word-boundary: char before `@` must be whitespace OR start-of-string
      const prev = i === 0 ? null : (value[i - 1] ?? null);
      if (prev === null || /\s/.test(prev)) {
        const query = value.slice(i + 1, cursorPos);
        // Reject queries containing whitespace — picker closes when user types space
        if (/\s/.test(query)) return { active: false, query: "", atIndex: -1 };
        return { active: true, query, atIndex: i };
      }
      return { active: false, query: "", atIndex: -1 };
    }
    if (/\s/.test(ch)) {
      return { active: false, query: "", atIndex: -1 };
    }
  }
  return { active: false, query: "", atIndex: -1 };
}
